import React from "react";
import { IconProps } from "../icon";

export const Link_04Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M7.5 7H7a5 5 0 000 10h2a5 5 0 005-5m2.5 5h.5a5 5 0 000-10h-2a5 5 0 00-5 5"
    />
  </svg>
);
